module.exports = __webpack_public_path__ + "media/images/countryrect/sm-954f2e0f8a73a3cf4e3731ba0a3db14a.svg";